import { defineComponent as _defineComponent } from 'vue'
import { customersService } from '@/services/tenants.service';
import { shiftModelsService } from '@/services/shiftModels.service';
import { ShiftModel } from '@/models/shiftModel';
import { Logger } from '@/utils/logger';
import { useI18n } from '@/composables/i18n';
import { isNil, uniqueId } from '@/utils/misc';
import { Shift } from '@/models/shift';
import { shiftsService } from '@/services/shifts.service';
import { computed, onMounted, ref } from 'vue';
import { ValidationRules } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftModelSelect',
  props: {
    value: null,
    customerId: null,
    rules: { default: () => ({}) },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: number) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: number, customerId?: number, rules: ValidationRules, disabled: boolean };





const { t } = useI18n();
const componentId = uniqueId();
const shiftModels = ref<ShiftModel[]>([]);
const isLoading = ref<boolean>(false);

const selectedShiftModelId = computed<number | null>({
  get() {
    return props.value ?? null;
  },
  set(newShiftModelId) {
    emit('input', newShiftModelId!);
  },
});

const validations = {
  shiftModelId: props.rules,
};

const v$ = useVuelidate(validations, {
  shiftModelId: selectedShiftModelId,
});

onMounted(async () => {
  shiftModels.value = await fetchShiftModels();
});

async function fetchShiftModels(): Promise<ShiftModel[]> {
  isLoading.value = true;

  try {
    const customerId = props.customerId ?? customersService.store.current()!.id;
    return await shiftModelsService.get(customerId);
  } catch (e) {
    Logger.error('Error loading shift models', e);
    return [];
  } finally {
    isLoading.value = false;
  }
}

function getShifts(shiftModelId: number): Shift[] {
  return shiftsService.store.getAllByShiftModelId(shiftModelId);
}

const triggerLabel = computed((): string => {
  if (isNil(props.value)) {
    return t('inputs.shift_model_select.placeholder').toString();
  }

  if (props.value === ShiftModel.NONE_ID) {
    return t('inputs.shift_model_select.no_shift_model').toString();
  }

  return selectedShiftModel.value?.name ?? '';
});

const selectedShiftModel = computed((): ShiftModel | undefined =>
  shiftModels.value.find((shiftModel) => shiftModel.id === props.value),
);

const required = computed(() => 'required' in props.rules);

const validationMessage = computed(
  () => v$.value.shiftModelId?.$errors[0]?.$message,
);

return { __sfc: true,props, emit, t, componentId, shiftModels, isLoading, selectedShiftModelId, validations, v$, fetchShiftModels, getShifts, triggerLabel, selectedShiftModel, required, validationMessage, ShiftModel, isNil }
}

})